var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-card mb-3",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"menu-left"},[(_vm.iconClass)?_c('i',{class:_vm.iconClass}):_vm._e(),_vm._t("icon")],2),_c('div',{staticClass:"menu-label"},[_c('span',[_vm._v(_vm._s(_vm.label))])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-right"},[_c('i',{staticClass:"fas fa-angle-right"})])
}]

export { render, staticRenderFns }